import { render, staticRenderFns } from "./PreOrderDetailSuperAdmin.vue?vue&type=template&id=05dff8d9&scoped=true"
import script from "./PreOrderDetailSuperAdmin.vue?vue&type=script&lang=js"
export * from "./PreOrderDetailSuperAdmin.vue?vue&type=script&lang=js"
import style0 from "./PreOrderDetailSuperAdmin.vue?vue&type=style&index=0&id=05dff8d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dff8d9",
  null
  
)

export default component.exports